import * as z from "zod/v4";

export const generateGoogleReviewFeed = {
  name: "generateGoogleReviewFeed" as const,
  input: z.object({ teamId: z.string() }),

  output: z.object({
    success: z.boolean(),
    feedUrl: z.string(),
    reviewCount: z.number(),
    generatedAt: z.date(),
  }),
};
